// generated from 3_064_351 samples

import { z } from "zod";
import { triggerGetSchema } from "./triggerGetSchema";

export const orBehaviorTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::OrBehavior"),
  get sub_behaviors(): z.ZodArray<z.ZodType<any>> {
    return z.array(triggerGetSchema);
  },
});
